import { formattedCount } from "helpers/system";
import React, { Component } from "react";

export default class ChatArrow extends Component {
    scrollToBottom = () => {
        const { contentHeight, visibleHeight } = this.props.scroll;
        this.props.removeArrow();
        this.props.scroll.updateScrollPosition(contentHeight - visibleHeight);
    };

    render() {
        const { newMsgCount } = this.props;
        if (newMsgCount) {
            return (
                <div className="chat__arrow-wrapper">
                    {newMsgCount > 0 && (
                        <span className="chat__count-new-messages">{formattedCount(newMsgCount)}</span>
                    )}
                    <span className="chat__arrow" onClick={this.scrollToBottom} />
                </div>
            );
        }
        return null;
    }
}
